<template>
  <div class="accounts-list">
    <div class="accounts-list__header">
      <Header />
      <ui-button
        color="primary"
        icon="icon-plus"
        @click="handleAddAccount"
        :loading="isAccountCreating"
      >
        {{ $t("message.common.addAccount") }}
      </ui-button>
    </div>
    <InfoBox :text="$t('message.mobile.googlePlay.listings.info')" />
    <AccountsExpansionPanel
      :accounts="accounts"
      :loading="isAccountsLoading"
      @delete-account="deleteAccount"
    />
    <SectionLoader v-if="showLoader" :status="isAccountsLoading" :opacity="1" />
  </div>
</template>

<script>
import Header from "@/components/GooglePlay/Header.vue";
import googlePlayService from "@/services/googlePlay";
import AccountsExpansionPanel from "@/components/GooglePlay/AccountsExpansionPanel.vue";
import InfoBox from "@/components/ui/InfoBox.vue";
import SectionLoader from "@/components/Loader/SectionLoader.vue";
import { googlePlayApiConfig } from "@/config/google-play-api";
export default {
  name: "GooglePlayList",
  components: {
    Header,
    AccountsExpansionPanel,
    InfoBox,
    SectionLoader
  },
  data() {
    return {
      isAccountsLoading: false,
      isAccountCreating: false,
      accounts: [],
      clientId: googlePlayApiConfig.clientId,
      scope: googlePlayApiConfig.scope
    };
  },
  created() {
    this.fetchAccounts();
  },
  mounted() {
    this.addGoogleIdentityScript();
  },
  methods: {
    addGoogleIdentityScript() {
      if (document.querySelector("#googleIdentityScript")) return;
      const googleIdentityScript = document.createElement("script");
      googleIdentityScript.setAttribute(
        "src",
        "https://accounts.google.com/gsi/client"
      );
      googleIdentityScript.setAttribute("async", "");
      googleIdentityScript.setAttribute("defer", "");
      googleIdentityScript.setAttribute("id", "googleIdentityScript");
      document.head.appendChild(googleIdentityScript);
    },
    fetchAccounts() {
      this.isAccountsLoading = true;
      googlePlayService
        .getAccounts()
        .then(({ data }) => {
          this.accounts = data;
        })
        .finally(() => {
          this.isAccountsLoading = false;
        });
    },
    deleteAccount(accountId) {
      googlePlayService.deleteAccount(accountId).then(() => {
        this.fetchAccounts();
      });
    },
    async handleAddAccount() {
      this.isAccountCreating = true;
      window.google.accounts.oauth2
        .initCodeClient({
          client_id: this.clientId,
          scope: this.scope,
          ux_mode: "popup",
          error_callback: () => {
            this.isAccountCreating = false;
          },
          callback: async ({ code }) => {
            googlePlayService.createGooglePlayAccount(code).then(() => {
              this.fetchAccounts();
              this.isAccountCreating = false;
            });
          }
        })
        .requestCode();
    }
  },
  computed: {
    showLoader() {
      return this.isAccountsLoading && this.accounts.length === 0;
    }
  }
};
</script>
<style lang="scss" scoped>
.accounts-list {
  padding: $spacing * 3;
  display: flex;
  flex-direction: column;
  gap: $spacing * 3;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
